module.exports = __webpack_public_path__ + "img/hash.56a849ac.svg";